export const icons = {
	phone: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='18'
			height='18'
			viewBox='0 0 18 18'>
			<path d='M-127.77 -183.93L-176.565 -139.627C-191.003 -126.517 -197.423 -106.755 -193.425 -87.6674C-177.945 -13.7775 -117.952 165.743 103.335 210.653C123.728 214.793 144.735 207.27 157.763 191.04L202.418 135.375C214.845 119.88 212.228 97.2151 196.59 84.9676L154.74 52.185C142.043 42.24 124.253 42.045 111.345 51.72L62.0925 88.6201C62.0925 88.6201 -36.2325 56.7901 -70.815 -44.31L-33.1125 -95.7225C-22.5825 -110.085 -24.255 -130.005 -37.0275 -142.41L-78.93 -183.105C-92.4375 -196.222 -113.82 -196.582 -127.77 -183.922V-183.93Z' />
			<path d='M3.975 1.84495L2.1675 3.48745C1.635 3.97495 1.395 4.70245 1.545 5.41495C2.115 8.15245 4.3425 14.805 12.54 16.4625C13.2975 16.6125 14.07 16.335 14.5575 15.735L16.215 13.6725C16.6725 13.095 16.575 12.2625 15.9975 11.805L14.445 10.59C13.9725 10.2225 13.3125 10.215 12.84 10.575L11.0175 11.94C11.0175 11.94 7.3725 10.7625 6.0975 7.01995L7.4925 5.11495C7.8825 4.58245 7.8225 3.84745 7.35 3.38245L5.7975 1.87495C5.295 1.38745 4.5075 1.37245 3.99 1.84495H3.975Z' />
		</svg>
	),

	arrow: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 16 16'>
			<path d='M6.11085 7.98292L11.0195 12.8916L9.91112 14L5.00244 9.09133L6.11085 7.98292Z' />
			<path d='M4.99995 6.90868L9.90863 2L11.017 3.10841L6.10836 8.01709L4.99995 6.90868Z' />
		</svg>
	),

	arrowRight: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1067 1024'>
			<g id='icomoon-ignore'></g>
			<path d='M798.327 550.242c0.674-35.972-8.768-71.949-29.457-102.076-19.558-28.779-40.695-57.333-65.199-82.065-111.97-112.193-191.787-191.111-330.737-266.432-11.692-6.295-24.957-10.567-37.998-13.041-23.833-4.497-44.742 2.698-60.256 21.809-42.944 54.185 23.383 104.774 60.481 137.825 107.697 95.556 233.38 176.722 316.345 296.785 3.149 4.719 6.519 10.116 5.171 15.514-1.122 4.271-4.497 7.194-7.868 9.89-67.678 56.435-142.771 108.821-215.394 161.212-57.334 41.37-171.776 100.501-176.722 181.666-2.923 47.889 52.612 69.7 92.858 60.932 20.91-4.497 40.021-14.618 58.458-25.634 73.296-43.392 138.726-99.375 206.851-149.965 58.005-42.944 120.286-87.91 157.158-151.539 16.64-28.557 25.634-61.606 26.082-94.656l0.226-0.226z' />
		</svg>
	),

	arrowLeft: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1067 1024'>
			<g id='icomoon-ignore'></g>
			<path d='M226.841 550.242c-0.675-35.972 8.768-71.949 29.454-102.076 19.561-28.779 40.695-57.333 65.203-82.065 111.971-112.193 191.787-191.111 330.735-266.432 11.691-6.295 24.956-10.567 37.999-13.041 23.829-4.497 44.74 2.698 60.254 21.809 42.944 54.185-23.381 104.774-60.48 137.825-107.699 95.556-233.382 176.722-316.346 296.785-3.148 4.719-6.52 10.116-5.172 15.514 1.124 4.271 4.497 7.194 7.869 9.89 67.675 56.435 142.772 108.821 215.395 161.212 57.331 41.37 171.772 100.501 176.721 181.666 2.923 47.889-52.612 69.7-92.86 60.932-20.907-4.497-40.021-14.618-58.458-25.634-73.297-43.392-138.722-99.375-206.849-149.965-58.008-42.944-120.288-87.91-157.161-151.539-16.638-28.557-25.631-61.606-26.081-94.656l-0.225-0.226z' />
		</svg>
	),

	check: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 64 64'>
			<path d='M27 55L6 33 9 29 26 41 55 12 59 16z' />
		</svg>
	),

	arrowMarker: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 512.000000 512.000000'>
			<g transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'>
				<path d='M155 4930 c-74 -12 -126 -58 -145 -129 -25 -93 -61 -39 796 -1182 l794 -1059 -794 -1059 c-865 -1153 -823 -1091 -797 -1188 13 -47 75 -109 118 -119 16 -3 34 -8 42 -10 7 -2 32 1 54 7 40 11 4666 2142 4782 2202 34 18 69 46 81 65 49 73 38 173 -25 231 -27 25 -645 314 -2426 1136 -1314 606 -2401 1104 -2415 1107 -14 3 -43 2 -65 -2z' />
			</g>
		</svg>
	),

	facebook: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'>
			<path
				fill='var(--white)'
				d='M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24h11.495v-9.294h-3.13v-3.622h3.13V8.413c0-3.1 1.893-4.787 4.658-4.787 1.325 0 2.463.099 2.794.143v3.24h-1.916c-1.504 0-1.795.715-1.795 1.765v2.313h3.59l-.467 3.622h-3.123V24h6.116c.728 0 1.325-.597 1.325-1.325V1.325C24 .597 23.403 0 22.675 0z'
			/>
		</svg>
	),

	instagram: (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'>
			<path
				fill='var(--white)'
				d='M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.92 4.92.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.148 3.225-1.664 4.771-4.92 4.92-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-3.225-.148-4.771-1.664-4.92-4.92-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.148-3.225 1.664-4.771 4.92-4.92 1.266-.058 1.646-.07 4.85-.07m0-2.163C8.753 0 8.329 0 7.054.07c-4.39.2-6.785 2.595-6.985 6.985C0 8.329 0 8.753 0 12s0 3.671.07 4.946c.2 4.39 2.595 6.785 6.985 6.985C8.329 24 8.753 24 12 24s3.671 0 4.946-.07c4.39-.2 6.785-2.595 6.985-6.985C24 15.671 24 15.247 24 12s0-3.671-.07-4.946c-.2-4.39-2.595-6.785-6.985-6.985C15.671 0 15.247 0 12 0z'
			/>
			<path
				fill='var(--white)'
				d='M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-10.406a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z'
			/>
		</svg>
	),

	play: (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='var(--white)'
			xmlns='http://www.w3.org/2000/svg'>
			<path d='M8 5v14l11-7z' />
		</svg>
	),

	pause: (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='var(--white)'
			xmlns='http://www.w3.org/2000/svg'>
			<path d='M6 5h4v14H6zM14 5h4v14h-4z' />
		</svg>
	),
};
